import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { validatePassword } from 'firebase/auth';
import { EventService } from 'src/app/core/services/event.service';
import { ApiService } from 'src/app/shared/services/api.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-partner-manager',
  templateUrl: './partner-manager.component.html',
  styleUrls: ['./partner-manager.component.scss']
})
export class PartnerManagerComponent implements OnInit {

  constructor(
    private apiService: ApiService,
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    private eventService: EventService,
    private translateService: TranslateService,
    public router: Router
    // private modalService: NzModalService,
    // private notification: NzNotificationService
  ) { }
  searchTerm
  // listData = []
  listData = <any>[]
  pageSize = 10
  pageIndex = 1
  totalCount = 0
  tableName = 'partner-management/partners'
  listStatus = ['0','1']
  listRole = [
    { value: 1, label: 'Admin' },
    { value: 2, label: 'User' },
    { value: 3, label: 'Customer Service' }
  ];
    // listRole = ['Quản trị viên','Người dùng']
  role = JSON.parse(localStorage.getItem('currentUser')).role;

  submitted: boolean
  formData: FormGroup

  breadCrumbItems

  get form() {
    return this.formData.controls
  }

  ngOnInit() {
    this.breadCrumbItems = [{ label: 'PAGE.HOME' }, { label: 'PAGE.REPORT.IncidentType', active: true }];

    this.fetchData()
  }

  onChangePage(e) {
    this.pageIndex = e
    this.fetchData()
  }


  fetchData(params = '') {

    params = '&order=updated_at&direction=desc'
    this.eventService.setLoading(true)
    this.apiService.getList(this.tableName + `?page=${this.pageIndex}&limit=${this.pageSize}${params}`
    ).subscribe({
      next: (res) => {
        // this.listData = res
        // console.log(this.listData[1]['id'])
        this.listData = res.metadata['results'] || [];
        this.totalCount = res.metadata['pagination']['totalCount'] || 0;
        // // this.totalCount = res.meta.total
        this.eventService.setLoading(false)
      }
    })
  }

  addLang() {
    const language = this.form.language as FormArray
    let lang = this.makePrice()
    language.push(lang)
  }

  removeLang(i) {
    const language = this.form.language as FormArray
    language.removeAt(i)
  }

  openModal(content: any) {
    // this.apiService.successmsg()
    this.submitted = false
    this.formData = this.makeForm()
    let a = this.modalService.open(content, { centered: true, scrollable: true, size: 'lg' });
  }

  onEdit(data, content) {
    console.log(data)
    this.formData = this.makeForm(data)
    // this.uploadedImage = data.media.url
    this.modalService.open(content, { centered: true, scrollable: true, size: 'xl' });
  }
  onDetail(data) {
    this.router.navigate(['users/details/' + data])
  }

  selectedIncident = null
  selectedKeyword = null

  makeFormKeyword(d) {
    let data = d ? d : <any>{}
    return this.formBuilder.group({
      id: [data.id],
      name: [data.name],
      incident_type_id: [data.incident_type_id]
    })
  }

  fetchKeyword() {
    this.dataKeyword = []
    this.eventService.setLoading(true)
    this.apiService.getList(`keyword?type_id=${this.selectedIncident.id}`).subscribe({
      next: res => {
        console.log(res)
        this.dataKeyword = [...res]
        this.eventService.setLoading(false)
      }
    })
  }

  dataKeyword = []

  formEditKeyword: FormGroup
  formNewKeyword: FormGroup
  editKeyword(data, index) {
    this.formEditKeyword = this.makeFormKeyword(data)
    this.selectedKeyword = data
  }

  onSubmitFormKeyword(type) {
    if (type == 1) {
      if (this.formEditKeyword.valid) {
        const value = this.formEditKeyword.value
        this.eventService.setLoading(true)
        this.apiService.editItem('keyword', value.id, value).subscribe({
          next: res => {
            this.selectedKeyword = null
            this.fetchKeyword()
            this.eventService.setLoading(false)

          }
        })
      }
    } else {
      if (this.formNewKeyword.valid) {
        const value = this.formNewKeyword.value
        this.eventService.setLoading(true)
        this.apiService.addItem('keyword', value).subscribe({
          next: res => {
            this.eventService.setLoading(false)
            this.formNewKeyword.reset({ incident_type_id: this.selectedIncident.id })
            this.fetchKeyword()
          }
        })
      }
    }
  }

  onOpenKeywordModal(content, incident) {
    this.selectedIncident = incident
    this.fetchKeyword()
    this.formNewKeyword = this.makeFormKeyword({ incident_type_id: this.selectedIncident.id })
    this.modalService.open(content, { centered: true, scrollable: true, size: 'xl' });
  }

  defaultPrices = [
    { condition: 1, price: 0, unit: '' },
    { condition: 2, price: 0, unit: '' }
  ]

  onDeleteKeyword(id) {
    if (id) {
      this.eventService.setLoading(true)
      this.apiService.deleteItem('keyword', id).subscribe(res => {

        Swal.fire(this.translateService.instant('FORM.Success'), this.translateService.instant('FORM.SuccessMessageDelete'), 'success')
          .then(
            res => {
              this.fetchKeyword();

            }
          )
        this.eventService.setLoading(false)

      }

      )
    }
  }

  onDelete(data) {
    Swal.fire({
      title: this.translateService.instant('Cảnh báo'),
      text: this.translateService.instant('Bạn có chắc chắn muốn xóa'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#34c38f',
      cancelButtonColor: '#ff3d60',
      confirmButtonText: this.translateService.instant('FORM.WarningConfirm'),
      cancelButtonText: this.translateService.instant('FORM.Cancel')

    }).then(result => {
      if (result.value) {
        console.log(data)
        this.apiService.deleteItem(this.tableName, data).subscribe(res =>
          Swal.fire(this.translateService.instant('FORM.Success'), this.translateService.instant('FORM.SuccessMessageDelete'), 'success')
            .then(
              res => {
                this.fetchData();
              }
            )
        )
      }
    });
  }


  makeForm(d?) {
    const data = d || {};
    return this.formBuilder.group({
      id: [data.id],
      partnerCode: [
        data.partner_code || '',
        [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)] // chỉ chữ và số
      ],
      partnerName: [
        data.partner_name || '',
        [Validators.required, Validators.pattern(/^[a-zA-Z0-9\s]*$/)] // chữ, số và dấu cách
      ],
    });
  }

  sanitizeInput(controlName: string) {
    const value = this.formData.get(controlName).value || '';
    const newValue = value.replace(/[^a-zA-Z0-9]/g, '');
    this.formData.get(controlName).setValue(newValue, { emitEvent: false });
  }


  validateStatus(control) {
    const value = control.value;

    // Kiểm tra xem giá trị là 0 hoặc 1 không
    if (value !== 0 && value !== 1) {
      return { 'invalidStatus': true };
    }

    return null; // Giá trị hợp lệ
  }

  makePrices(data = []) {
    let arr = new FormArray([]);
    data.forEach(i => {

      arr.push(this.makePrice(i))
    })
    return arr;
  }

  makePrice(d?) {
    let data = d ? d : <any>{}
    return this.formBuilder.group({
      key: [data.key, [Validators.required]],
      // price: [data.price, [Validators.required, Validators.min(0)]],
      value: [data.value, [Validators.required]],
      // id: [data.id]
    })
  }


  saveData() {
    this.submitted = true;

    if (this.formData.valid) {
      const payload = {
        partner_code: this.formData.value.partnerCode,
        partner_name: this.formData.value.partnerName
      };

      this.eventService.setLoading(true);

      this.apiService.addItem(
        'partner-management/partners',
        payload
      ).subscribe({
        next: () => {
          this.fetchData();
          this.modalService.dismissAll();
          this.apiService.showToast(
            this.translateService.instant('Thành công'),
            this.translateService.instant('Thêm mới đối tác thành công'),
            'success'
          );
          this.eventService.setLoading(false);
        },
        error: () => {
          this.apiService.showToast(
            this.translateService.instant('Lỗi'),
            this.translateService.instant('Thêm mới thất bại'),
            'error'
          );
          this.eventService.setLoading(false);
        }
      });
    }
  }
}
